/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PermissionErrorDetails { 
    /**
     * Kind of entity, against which security permissions are violated
     */
    entity_type: PermissionErrorDetails.EntityTypeEnum;
    /**
     * Identifier of the entity, against which security permissions are violated
     */
    entity_id: string;
    /**
     * Name of an attempted operation on the entity
     */
    action: string;
}
export namespace PermissionErrorDetails {
    export type EntityTypeEnum = 'Account' | 'User' | 'Community' | 'CharityCommunity' | 'Project' | 'Post' | 'Comment' | 'Conversation' | 'File' | 'Folder' | 'File Activity Log' | 'Doctor patient link' | 'Signup invitation' | 'Deactivation incident' | 'Individual' | 'Organization' | 'Notification preferences' | 'Category' | 'Subcategory';
    export const EntityTypeEnum = {
        Account: 'Account' as EntityTypeEnum,
        User: 'User' as EntityTypeEnum,
        Community: 'Community' as EntityTypeEnum,
        CharityCommunity: 'CharityCommunity' as EntityTypeEnum,
        Project: 'Project' as EntityTypeEnum,
        Post: 'Post' as EntityTypeEnum,
        Comment: 'Comment' as EntityTypeEnum,
        Conversation: 'Conversation' as EntityTypeEnum,
        File: 'File' as EntityTypeEnum,
        Folder: 'Folder' as EntityTypeEnum,
        FileActivityLog: 'File Activity Log' as EntityTypeEnum,
        DoctorPatientLink: 'Doctor patient link' as EntityTypeEnum,
        SignupInvitation: 'Signup invitation' as EntityTypeEnum,
        DeactivationIncident: 'Deactivation incident' as EntityTypeEnum,
        Individual: 'Individual' as EntityTypeEnum,
        Organization: 'Organization' as EntityTypeEnum,
        NotificationPreferences: 'Notification preferences' as EntityTypeEnum,
        Category: 'Category' as EntityTypeEnum,
        Subcategory: 'Subcategory' as EntityTypeEnum
    };
}